const ENABLED_VAR = 'VITE_ANALYTICS_ENABLED';
const SESSION_RECORDING_VAR = 'VITE_DISABLE_SESSION_RECORDING';

const parseBool = (varName, raw) => {
  if (raw === undefined) return false;

  const normalized = raw.trim().toLowerCase();

  if (normalized === '') return false;
  if (normalized === 'true') return true;
  if (normalized === 'false') return false;

  // eslint-disable-next-line no-console
  console.warn(
    `[Analytics] ${varName}="${raw}" is not 'true' or 'false' — treating as false. Check for typo / whitespace.`,
  );

  return false;
};

// Vite inlines import.meta.env.VITE_* at build time, so these values cannot
// change at runtime. Resolve + warn once at module load instead of on every
// caller render.
const ANALYTICS_ENABLED = parseBool(ENABLED_VAR, import.meta.env.VITE_ANALYTICS_ENABLED);
const SESSION_RECORDING_DISABLED = parseBool(
  SESSION_RECORDING_VAR,
  import.meta.env.VITE_DISABLE_SESSION_RECORDING,
);

export const isAnalyticsEnabled = () => ANALYTICS_ENABLED;

export const isSessionRecordingDisabled = () => SESSION_RECORDING_DISABLED;
